<script>
export default {
  name: "FieldLabel",
  inject: [ 'store'],
  props: ["field"],
  computed:{
    hideField: {
      get(){
        return this.field.id ? this.store.resetterCache[this.field.id + '_hide'] : ''
      }
    }
  }
}
</script>


<template>
  <label 
    :for="this.field.id" 
    v-if="field.type != 'note' && !hideField"
  >{{ field.title }}</label>
</template>